<template>
  <span class="custom-checkbox-box">
    <span class="simulate-checkbox">
      <input
        type="checkbox"
        :checked="checked"
        :name="name"
        :id="id"
        @input="handleChange"
      />
      <span class="simulate-checkbox-self"></span>
    </span>
    <label class="label" :for="id" v-if="label">{{ label }}</label>
  </span>
</template>
<script>
export default {
  name: "custom-check-box",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: () => `id_${Date.now().toString()}`
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      checked: this.value
    };
  },

  methods: {
    handleChange(e) {
      this.checked = e.target.checked;
      this.$emit("change", e.target.checked);
    }
  }
};
</script>
<style lang="less" scoped>
.custom-checkbox-box {
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: top;

  .simulate-checkbox {
    position: relative;
    width: 17px;
    height: 17px;
  }

  input[type="checkbox"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;

    &:checked + .simulate-checkbox-self {
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;

      &::before {
        content: "";
        width: 4px;
        height: 8px;
        margin-top: -2px;
        border-right: 3px solid #008077;
        border-bottom: 3px solid #008077;
        transform: rotate(45deg);
      }
    }
  }

  .simulate-checkbox-self {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    border: 1px solid #acacac;
  }

  .label {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomCheckBox/index.vue